// 사용자 평점(피드백) API 호출.
// apiFetch<T>를 통해 JWT·refresh 횡단 관심사를 재사용한다.

import { apiFetch } from '~/api/client'
import type { FeedbackRequest } from '~/api/types'

/** 채팅 답변·평가 리포트 등에 대한 사용자 평점을 보낸다. */
export function sendFeedback(body: FeedbackRequest): Promise<void> {
    return apiFetch<void>('/feedback', { method: 'POST', body })
}
